import React, { ForwardedRef } from 'react';

import { useSelector } from 'react-redux';

import { StatusEnum } from '@common/constants';

import { WellnessTypesEnum } from '../../constants';
import { sleepDataSelector, getItemsSelector } from '../../store';
import { Dashboard, useDashboard } from '../Dashboard';
import { MEASUREMENT_TYPES } from './constants';
import { locale } from './locale';

type FitnessDashboardComponent = {
  setRef: ForwardedRef<HTMLDivElement>;
};

export function SleepDashboardComponent({ setRef }: FitnessDashboardComponent) {
  const { requestLogStatus, summaryData, summaryMonth, removeStatus } = useSelector(sleepDataSelector);
  const items = useSelector(getItemsSelector(WellnessTypesEnum.Sleep));

  const { chartData, handleHistoryItemClick, handleRecordButtonClick, handleDeleteItemClick } = useDashboard({
    summaryMonth,
    summaryData,
    type: WellnessTypesEnum.Sleep,
  });

  return (
    <div ref={setRef}>
      <Dashboard
        type={WellnessTypesEnum.Sleep}
        heading={locale.dashboard_title}
        chartTitle={locale.title}
        data={chartData}
        measurements={MEASUREMENT_TYPES}
        selectedMeasurement={MEASUREMENT_TYPES[0]}
        historyItems={items}
        historyTitle={locale.history_title}
        loading={
          [StatusEnum.Pending, StatusEnum.Uninitialized].includes(requestLogStatus) ||
          removeStatus === StatusEnum.Pending
        }
        recordButtonText={locale.record_activity}
        onRecordButtonClick={handleRecordButtonClick}
        onEditItemClick={handleHistoryItemClick}
        onDeleteItemClick={handleDeleteItemClick}
      />
    </div>
  );
}

export const SleepDashboard = React.forwardRef<HTMLDivElement>((props, ref) => (
  <SleepDashboardComponent setRef={ref} {...props} />
));

SleepDashboard.displayName = 'SleepDashboard';
